<template>
  <div
    :class="`playlist-container ra-playlist--${aspectRatio}`"
    :data-refapp-tagging-id="taggingId"
  >
    <template v-if="currentVideo">
      <div :class="`main-slide ra-playlist--ratio-${aspectRatio}`">
        <div v-if="!isCurrentVideoPlaying" class="main-slide__thumbnail">
          <div class="main-slide__image">
            <img
              :src="currentVideo?.largeThumbnailImage?.src"
              :alt="currentVideo?.largeThumbnailImage?.alt"
            />
          </div>
          <div class="main-slide__content">
            <p v-if="showVideoNumber" class="main-slide__video-number">{{ currentVideo.index }}</p>
            <h2 class="main-slide__title">{{ currentVideo.title }}</h2>
            <p class="main-slide__description">{{ currentVideo.description }}</p>
            <a
              class="main-slide__link"
              :class="currentVideo.cta.style"
              :href="currentVideo.cta.url"
              :data-refapp-tagging-target="`video-cta-${currentVideo.index}`"
            >
              {{ currentVideo.cta.text }}
            </a>
            <i class="main-slide__play-icon" @click="playVideo"></i>
          </div>
        </div>
        <refapp-video-provider
          v-if="isCurrentVideoPlaying && currentVideo.internalVideoId"
          v-bind="internalVideoArgs"
        >
          <refapp-video></refapp-video>
        </refapp-video-provider>
        <async-youtube-embed
          v-if="isCurrentVideoPlaying && currentVideo.youtubeId"
          :class="`main-slide__youtube-embed ra-playlist--ratio-${aspectRatio}`"
          :muted="muted"
          :autoplay="autoplay"
          :video-id="currentVideo.youtubeId"
        />
      </div>

      <div class="playlist">
        <h3 class="playlist__title">{{ titleLabel }}</h3>
        <ul>
          <li
            v-for="(video, index) in items"
            :key="index"
            :class="{ active: video.index === currentVideo.index }"
          >
            <div class="playlist__thumbnail-container">
              <div class="playlist__thumbnail" @click="selectVideo(video)">
                <img :src="video.smallThumbnailImage.src" :alt="video.smallThumbnailImage.alt" />
                <p v-if="showVideoNumber" class="playlist__video-number">{{ video.index }}</p>
                <p v-if="video.index === currentVideo.index" class="playlist__label">
                  {{ nowShowingLabel }}
                </p>
                <i v-if="video.index !== currentVideo.index" class="playlist__icon" alt="play"></i>
              </div>
              <p class="playlist__thumbnail-title">{{ video.title }}</p>
            </div>
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import RefappVideoProvider from './base/provider.vue';
import RefappVideo from './refapp-video.vue';

export default {
  name: 'refapp-playlist',
  components: {
    RefappVideoProvider,
    RefappVideo,
    AsyncYoutubeEmbed: defineAsyncComponent(() => import('./playlist/youtube-embed.vue')),
  },
  inject: [
    'index',
    'showVideoNumber',
    'autoplay',
    'muted',
    'aspectRatio',
    'nowShowingLabel',
    'titleLabel',
    'items',
    'taggingId',
  ],
  data() {
    return {
      currentVideo: null,
      isCurrentVideoPlaying: this.autoplay,
    };
  },
  computed: {
    internalVideoArgs() {
      return {
        autoplay: this.autoplay,
        muted: this.muted,
        controls: true,
        loop: true,
        sources: [this.currentVideo.internalVideoId],
      };
    },
  },
  mounted() {
    this.currentVideo = this.items[0];
  },
  methods: {
    selectVideo(video) {
      this.currentVideo = video;
      this.resetCurrentVideoPlaying();
    },
    playVideo() {
      this.isCurrentVideoPlaying = true;
    },
    resetCurrentVideoPlaying() {
      this.isCurrentVideoPlaying = this.autoplay;
    },
  },
};
</script>
<style lang="scss">
@use '../styles/entry.scss';
</style>
